import React, { useState, useEffect } from 'react';
import Loading from '@intelligence/components/Loading';
import useSearchParams from '@gp/hooks/useSearchParams';
import { getTicketDatas } from '@intelligence/services/common';
import { buriedPointPage } from '@home/utils/buriedPoint';
import { dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';
import { checkUrlWoa } from './utils';

import './index.scss';

export default function SteamMetrics() {
  const { id = 'fcb4bdaa99d6aa1a' } = useSearchParams();

  const [loading, setLoading] = useState(true);
  const [tableauUrl, setTableauUrl] = useState('');

  let gReqId = 0;

  const init = async (id: string) => {
    try {
      setLoading(true);
      // eslint-disable-next-line no-plusplus
      const reqId = ++gReqId;
      const result = await getTicketDatas({ tableau_site_id: id });
      let url = '';
      if (checkUrlWoa() && result?.data?.full_url_inner && result?.data?.full_url_inner != '') {
        url = reqId === gReqId ? result?.data?.full_url_inner : '';
      } else {
        url = reqId === gReqId ? result?.data?.full_url : '';
      }
      setTableauUrl(url || '');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      init(id);
      buriedPointPage(dbiPageLogMes.potentialSteamMetrics);
    }
  }, [id]);

  return (
    <div className="tableau-container">
      {loading && <Loading />}
      {!loading && tableauUrl && <iframe className="il-tableau-iframe" src={tableauUrl}></iframe>}
    </div>
  );
}
